import React, { Suspense, lazy } from 'react'
import { Route } from 'react-router-dom'
import Preloader from '../components/Preloader/Preloader'
import VerifyContainer from '../modules/Verify/VerifyContainer'
import VideoProjectContainer from '../modules/Verify/VideoProjectContainer'
import { BrandLoginForward, BrandPromoForward } from '../components/BrandRedirect/BrandRedirect'
const AuthCallbackContainer = lazy(() => import('../modules/AuthCallback/AuthCallbackContainer'))
const LogoutContainer = lazy(() => import('../modules/Logout/LogoutContainer'))
const LoginContainer = lazy(() => import('../modules/Login'))

// Studio's own login page is for local testing only. Deployed dev and prod
// forward its URLs to brand, so old links still reach a real sign-in.
const IS_LOCAL = process.env.NODE_ENV === 'development'

const localLogin = (
  <Suspense fallback={<Preloader />}>
    <LoginContainer />
  </Suspense>
)

export const publicRoutes = [
  <Route key='home' path='/' element={<VerifyContainer />} />,
  <Route key='verify' path='/verify' element={<VerifyContainer />} />,
  <Route key='video-project' path='/video-project' element={<VideoProjectContainer />} />,
  <Route
    key='logout'
    path='/logout'
    element={
      <Suspense fallback={<Preloader />}>
        <LogoutContainer />
      </Suspense>
    }
  />,
  <Route key='login' path='/login' element={IS_LOCAL ? localLogin : <BrandLoginForward />} />,
  // Landing point for the brand -> studio sign-in handoff. Separate from
  // /verify, which legacy web still drives; both stay until web is retired.
  <Route
    key='auth-callback'
    path='/auth/callback'
    element={
      <Suspense fallback={<Preloader />}>
        <AuthCallbackContainer />
      </Suspense>
    }
  />,
  <Route key='e3ud0s' path='/e3ud0s' element={IS_LOCAL ? localLogin : <BrandPromoForward />} />
]
